import { Button, Form, Input } from 'antd'
import { v4 as uuidv4 } from 'uuid'

const FilterForm = ({ handleSearch, setFilters }) => {
  const [form] = Form.useForm()

  const handleReset = () => {
    form.resetFields()
    setFilters({ currentPage: 1, pageSize: 10, reset: uuidv4() })
  }

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSearch}
      style={{ marginTop: 10 }}
      onValuesChange={(value, allValues) => {
        setFilters((prev) => ({ ...prev, ...allValues }))
      }}
    >
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '16px',
          alignItems: 'center'
        }}
      >
        <div style={{ flex: '1 1 240px', minWidth: '240px' }}>
          <Form.Item label="Tên nhãn hàng" name="partner_name">
            <Input
              placeholder="Nhập tên nhãn hàng"
              onBlur={(e) => {
                form.setFields([
                  {
                    name: 'partner_name',
                    value: e.target.value?.trim()
                  }
                ])
              }}
            />
          </Form.Item>
        </div>

        <div
          style={{
            display: 'flex',
            gap: '8px',
            justifyContent: 'flex-end',
            flex: '1 1 200px',
            minWidth: '200px'
          }}
        >
          <Button onClick={handleReset}>Đặt lại</Button>
          <Button type="primary" htmlType="submit" style={{ margin: '0 8px' }}>
            Tìm kiếm
          </Button>
        </div>
      </div>
    </Form>
  )
}

export default FilterForm
